import React, { useState } from 'react'
import List from './Components/List'
import Create from './Components/Create'
import ExcelFileUploadHandler from '../../UIComponents/ExcelFileUploadHandler';
import { useParams } from 'react-router-dom';
import { postAPI, postAPIForm, getURL } from '../../app/api';
import { store } from '../../app/store';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

export default function RewardSetup() {
    const [is_edit, setIsEdit] = useState(false);
    const [edit_id, setEditId] = useState(0);
    const { exam_id } = useParams();
    const store_data = JSON.parse(store());
    const [FormData, setFormData] = useState({
        exam_id: exam_id
    });
    const [Error, setError] = useState([]);

    return (
        <>
            <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                    <div className="col-12 col-xl-12 col-sm-12 order-1 order-lg-2 mb-4 mb-lg-0">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { window.location.href = '/Admin/Setting/Exams'; }}>
                                Back
                            </button>
                            <p className='text-right mb-0'><small class="fw-bold py-3">Dashboard<span class="text-muted fw-light"> / Reward Setup</span> </small></p>
                        </div>
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className='card-title mb-0'>Reward Setup</h5>
                                <div>
                                    <Create BTNLabel={"Add New Reward Setup"} Header={is_edit ? "Update Reward Setup" : "Create Reward Setup"} Subheader="" PopupID="RewardSetup" is_edit={is_edit} setIsEdit={setIsEdit} edit_id={edit_id} setEditId={setEditId} />
                                </div>
                            </div>
                            <div className="card-datatable table-responsive">
                                <List PopupID="RewardSetup" setIsEdit={setIsEdit} setEditId={setEditId} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

